import React from "react";
import { Flex, Typography } from "antd";
import { SbTag } from "uiCore";

import { getInitials, countFunctions, countSubFunctions } from "./helper";
import { EntityAvatarStyled } from "./LegalEntityManagement.styles";

const { Text } = Typography;

const EntityPanelHeader = ({ entity, index }) => {
  const fnCount = countFunctions(entity);
  const subCount = countSubFunctions(entity);
  const buCount = entity.business_units?.length || 0;

  return (
    <Flex align="center" gap={14}>
      <EntityAvatarStyled shape="square" $index={index}>
        {getInitials(entity.legal_entity)}
      </EntityAvatarStyled>
      <Flex vertical>
        <Text strong>{entity.legal_entity}</Text>
        <Flex wrap align="center" gap={8}>
          <SbTag>{buCount} {buCount === 1 ? "BU" : "BUs"}</SbTag>
          <SbTag>{fnCount} {fnCount === 1 ? "function" : "functions"}</SbTag>
          <SbTag>{subCount} {subCount === 1 ? "sub-function" : "sub-functions"}</SbTag>
          {entity.currency_info?.local_currency && (
            <SbTag>{entity.currency_info.local_currency}</SbTag>
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default EntityPanelHeader;
